var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViewnot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.88 10.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notview"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.88,0H19.73a1.58,1.58,0,0,0-1.39.81,8.47,8.47,0,0,1-1.09,1.55,5.35,5.35,0,0,1-.45.5l-.24.22a8.56,8.56,0,0,1-2.32,1.57,7.55,7.55,0,0,1-.93.38,8.85,8.85,0,0,1-2.46.46h-.41l-.59,0A9.13,9.13,0,0,1,7.57,5a9.53,9.53,0,0,1-.93-.38A9.12,9.12,0,0,1,4.32,3.08a6.6,6.6,0,0,1-.69-.71A8.67,8.67,0,0,1,2.53.8,1.56,1.56,0,0,0,1.15,0H0L0,.06A11.57,11.57,0,0,0,2.25,3.75L1.1,4.9a.5.5,0,0,0,0,.71.46.46,0,0,0,.35.14.46.46,0,0,0,.35-.14L2.94,4.47a11.06,11.06,0,0,0,2.83,2L5,8.1a.5.5,0,0,0,.24.67h0a.5.5,0,0,0,.66-.24l.83-1.71a10.24,10.24,0,0,0,2.65.62l.47,0L9.76,9.93a.51.51,0,0,0,.49.51h0a.5.5,0,0,0,.5-.49l.05-2.46a11,11,0,0,0,3.38-.65L15,8.54a.5.5,0,0,0,.66.24h0a.5.5,0,0,0,.24-.67l-.8-1.64A10.63,10.63,0,0,0,18,4.5l1.11,1.11a.51.51,0,0,0,.7,0,.5.5,0,0,0,0-.71L18.68,3.79A11.48,11.48,0,0,0,20.75.35Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewnot);
export default __webpack_public_path__ + "static/media/icon-viewnot.3ec69e07a00609cf990006245a9e0d89.svg";
export { ForwardRef as ReactComponent };